module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/126.c5426afe.png";